import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-repair-diagram-dialog',
  templateUrl: './repair-diagram-dialog.component.html',
  styleUrls: ['./repair-diagram-dialog.component.scss'],
})
export class RepairDiagramDialogComponent implements OnInit {
  selectedTab: number = 0;
  link: string = '';
  serviceName: string = '';
  vehicleId: string = '';
  applicationId: string = '';
  roNum: string = '';
  options = {
    SM: '',
    CO: '',
    EN: '',
  };
  locations: any[] = [];
  illustrations: any[] = [];
  wirings: any[] = [];
  bulletins: any[] = [];
  procedures: any[] = [];
  specifications: any[] = [];
  fluids: any[] = [];
  moduleCount = {
    diagrams: 0,
    specs: 0,
    procedures: 0,
    wirings: 0,
    bulletins: 0,
  };
  isProcessing: boolean = true;
  documentUrls: any[] = [];
  isOpenFullScreen: boolean = false;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig, 
    private dynamicDialogRef: DynamicDialogRef, 
    public helperService: HelperService, 
    private httpService: HTTPService, 
    private dataService: DataService
  ) {}

  ngOnInit() {
    const { link, options, vehicleId, applicationId, displayName, roNum } = this.dynamicDialogConfig.data;

    this.serviceName = displayName;
    this.link = link;
    this.options = options;
    this.vehicleId = vehicleId;
    this.applicationId = applicationId;
    this.roNum = roNum;

    this.getComponentDiagrams();

    if (this.dataService.isGainSightPXEnabled && this.selectedTab === 0) {
      const eventName = 'Motor Repair Guides - Component & Diagrams';
      const payload = {
        roNum: this.roNum,
        vehicleId: this.vehicleId,
        applicationId: this.applicationId,
        displayName: this.serviceName,
      }
      this.helperService.postGainsightPXEvent(eventName, payload);
    }
  }

  getComponentDiagrams() {
    const data = {
      link: this.link,
      options: this.options,
      vehicleId: this.vehicleId,
      applicationId: this.applicationId,
    };
    this.isProcessing = true;
    this.httpService
      .getComponentDiagrams(data)
      .then(
        ({ wirings = [], locations = [], bulletins = [], procedures = {}, illustrations = [], specifications = [] }: any) => {
          // Populating locations and illustration - Component & Diagrams
          this.locations = locations.map((location: any) => ({
            ...location,
            displayName: (location.displayName || '').toLowerCase(),
          }));
          this.illustrations = illustrations.map((illustration: any) => ({
            ...illustration,
            displayName: (illustration.displayName || '').toLowerCase(),
          }));

          // Populating fluids & specifications - Specs
          this.specifications = specifications.specs;
          this.fluids = specifications.fluids;

          // Populating procedure - Procedure
          this.procedures = this.handleFormatProcedure(procedures.attributes, procedures.procedures);
          // Populating wirings - Wirings
          this.wirings = wirings;

          // Populating bulletin - Bulletins
          this.bulletins = bulletins;

          // Setting count
          this.moduleCount = {
            diagrams: this.locations.length + this.illustrations.length,
            specs: this.specifications.length + this.fluids.length,
            procedures: this.procedures.length,
            wirings: this.wirings.length,
            bulletins: this.bulletins.length,
          };
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => (this.isProcessing = false));
  }

  handleFormatProcedure(attributes: any, procedures: any[] = []) {
    const attrMap = this.helperService.getMappedAttribute(attributes);

    procedures.forEach((procedure) => {
      if (procedure.qualifier && procedure.qualifier.length) {
        const qualifiers = [];

        procedure.qualifier.forEach(({ IsActive, Description }) => {
          if (IsActive) qualifiers.push(Description);
        });

        if (qualifiers.length) {
          procedure.displayName += ' - ' + qualifiers.join(' - ');
        }
      }
      // procedure.displayName = this.helperService.makeMotorServiceName(procedure.displayName, null, '', procedure.qualifier, attrMap, procedure.attributes, '');
    });

    return procedures;
  }

  handleTabChange(selectedTab: number) {
    this.selectedTab = selectedTab;

    if (this.dataService.isGainSightPXEnabled && selectedTab >= 0 && selectedTab < 5) {
      let eventName = ''
      switch (selectedTab) {
        case 0:
          eventName = 'Motor Repair Guides - Component & Diagrams'
          break;
        case 1:
          eventName = 'Motor Repair Guides - Specs'
          break;
        case 2:
          eventName = 'Motor Repair Guides - Procedures'
          break;
        case 3:
          eventName = 'Motor Repair Guides - Wiring'
          break;
        case 4:
          eventName = 'Motor Repair Guides - Bulletins'
          break;
      }
      const payload = {
        roNum: this.roNum,
        vehicleId: this.vehicleId,
        applicationId: this.applicationId,
        displayName: this.serviceName,
      }
      this.helperService.postGainsightPXEvent(eventName, payload);
    }
  }

  handleopenFullScreen() {
    this.isOpenFullScreen = !this.isOpenFullScreen;
    const repairGuideDialog: HTMLDivElement = document.querySelector('.repair-diagram-dialog-ref');

    if (repairGuideDialog) {
      repairGuideDialog.style.width = this.isOpenFullScreen ? `${window.innerWidth}px` : null;
      repairGuideDialog.style.maxWidth = this.isOpenFullScreen ? `${window.innerWidth}px` : null;
      repairGuideDialog.style.height = this.isOpenFullScreen ? `${window.innerHeight}px` : null;
      repairGuideDialog.style.maxHeight = this.isOpenFullScreen ? `${window.innerHeight}px` : null;

      if (this.isOpenFullScreen) {
        repairGuideDialog.classList.add('rd-full-screen-container');
      } else {
        repairGuideDialog.classList.remove('rd-full-screen-container');
      }
    }
  }

  handleClose() {
    this.dynamicDialogRef.close();
  }
}
